export default __webpack_public_path__ + "static/media/logo192.505aca97.png";